import React from 'react';
import QuickEdit from '../QuickEdit/QuickEdit';

export default function QuickEditWrapper({ customer, customerUid, setCustomer, onCustomerSaved }) {
    // Pass the customerUid from QuickLink to QuickEdit so it can use the selected customer
    return (
        <QuickEdit hideHeader={true} customerUid={customerUid} onCustomerSaved={onCustomerSaved} />
    );
}

